<template>
  <div id="successLogin">
    <div class="login-title">
      <span class="title-left">登录成功</span>
      <span class="title-right"> Login Successful</span>
    </div>
    <div class="userHeaderImg">
      <img v-if="showUser.headImg" :src="showUser.headImg">
      <img v-if="!showUser.headImg" :src="$ebConfig.imgPath+'img/user-default.jpeg'" alt="">
    </div>
    <div class="userinfo ellipsis">姓&emsp;名：{{user.truename}}</div>
    <div class="userinfo ellipsis">机构名：{{showUser.companyName}}</div>
    <div class="userinfo ellipsis">角&emsp;色：{{user.roleName }}</div>
    <div>
      <el-button class="loginBtn" v-if="user.userRoles.length>1" @click="chooseRole()">切换角色</el-button>
    </div>
    <div>
      <el-button class="loginBtn" @click="quite()">退出</el-button>
    </div>
  </div>
</template>
<script>
import { getUserById } from '@/services/user/user-service';
export default {
  name: 'successLogin',
  data() {
    return {
      user: this.$store.state.user.userInfo,
      showUser: {}
    };
  },
  created() {
    if (this.user) {
      this.init();
    }
  },
  methods: {
    async init() {
      try {
        let { data } = await getUserById(this.user.userid);
        if (data.returnCode === '01') {
          this.showUser = data.user;
        } else {
          this.$message.error('获取用户信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    quite() {
      this.$store.dispatch('logout');
    },
    chooseRole() {
      this.$emit('onChangeRole');
    }
  }
};
</script>
<style lang="less">
#successLogin {
  .login-title {
    font-family: 'Microsoft YaHei';
    // padding-bottom: 30px;
    // padding-top: 30px;
    .title-left {
      color: #fb5b3b;
      font-size: 24px;
      margin: 0;
    }
    .title-right {
      color: gray;
      font-size: 14px;
    }
  }
  .userHeaderImg {
    height: 209px;
    width: 140px;
    display: flex;
    margin: 20px auto;
    display: flex;
    img {
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
  .userinfo {
    width: 194px;
    margin-left: 80px;
    height: 35px;
    color: #767676;
  }
  .loginBtn {
    width: 100%;
    background-color: #908d8d;
    border: 1px solid #908d8d;
    color: #fff;
    padding: 0.7em 0;
    font-size: 1.2em;
    margin-top: 20px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background-color: #fb5b3b;
    }
    &:focus {
      background-color: #fb5b3b;
    }
  }
}
</style>
